export class ClientsGrid {
	constructor() {
		this.container = document.querySelector('.clientsGrid');
		this.clientCount = [
			...this.container.querySelectorAll(
				'.clientsGrid-list.sr-only li picture'
			),
		];
		this.postCount = [
			...this.container.querySelectorAll(
				'.clientsGrid-list[aria-hidden="true"] li picture'
			),
		];
	}

	init() {
		const arrIndexToReplace = [];
		const max = this.postCount.length - 1;
		for (let i = 0; i <= max; i++) {
			let randomIndex = Math.floor(Math.random() * (max - 0 + 1) + 0);
			arrIndexToReplace.splice(randomIndex, 0, i);
		}

		let indexToShow = 5;
		let indexToReplace = 0;

		setInterval(() => {
			this.changeContent(indexToShow, arrIndexToReplace[indexToReplace]);
			indexToShow = (indexToShow + 1) % this.clientCount.length;
			indexToReplace = (indexToReplace + 1) % this.postCount.length;
		}, 1200);
	}

	changeContent(indexToShow, indexToReplace) {
		const newContent = this.clientCount[indexToShow];
		const thisElement = this.postCount[indexToReplace];

		thisElement.classList.add('fade-out');

		setTimeout(() => {
			thisElement.classList.remove('fade-out');
			thisElement.innerHTML = newContent.innerHTML;
			thisElement.classList.add('fade-in');
		}, 500);
	}
}
